import styled, { css, keyframes } from "styled-components";


export const PrimaryButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${({ height, theme }) => height || theme.button.primary.height};
  width: ${({ width }) => width};
  padding: ${({ padding }) => padding || "0 16px 0 16px"};
  margin: ${({ margin }) => margin || "0"};
  cursor: ${({ cursor }) => cursor || `pointer`};

  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.button.primary.bgColor};
  color: ${({ textColor, theme }) =>
    textColor || theme.button.primary.textColor};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.button.primary.fontWeight};
  border-radius: ${({ theme, borderRadius }) => borderRadius || theme.button.borderRadius};
  border: none;

  &:hover {
    background-color: ${({ hoverColor, disabled, theme }) =>
      !disabled && (hoverColor || theme.button.primary.hoverBgColor)};
  }
  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: ${({ disabledBgColor, theme }) =>
      disabledBgColor || theme.button.primary.disabledBgColor};
    cursor: not-allowed;
  }
`;

// div styled buttons
const CommonDivButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width};
  padding: ${({ padding }) => padding || "0 16px 0 16px"};
  letter-spacing: ${({ letterSpacing }) => letterSpacing || "0.5px"};
  cursor: ${({ cursor, disabled }) =>
    disabled ? "not-allowed" : cursor || `pointer`};
  border-radius: ${({ borderRadius, theme }) =>
    borderRadius || theme.button.borderRadius};
  margin: ${({ margin }) => margin};
`;
export const SecondaryButton = styled(CommonDivButton)`
  min-height: ${({ height, theme }) => height || theme.button.secondary.height};

  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.button.secondary.bgColor};
  color: ${({ textColor, theme }) =>
    textColor || theme.button.secondary.textColor};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.button.secondary.fontWeight};
  border: 1px solid
    ${({ borderColor, theme }) =>
      borderColor || theme.button.secondary.borderColor};

  &:hover {
    background-color: ${({ hoverBgColor, theme }) =>
      hoverBgColor || theme.button.secondary.hoverBgColor};
    border-color: ${({ hoverBgColor, theme }) =>
      hoverBgColor || theme.button.secondary.hoverBgColor};
    color: ${({ hoverTextColor, theme }) =>
      hoverTextColor || theme.button.secondary.hoverTextColor};
  }
`;
export const WhiteButton = styled(CommonDivButton)`
  min-height: ${({ height, theme }) => height || theme.button.height};
  height: max-content;
  width: ${({ width }) => width || "auto"};
  padding: ${({ padding }) => padding || "0 16px 0 16px"};

  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.colors.main.white};
  color: ${({ color, type, theme }) =>
    color
      ? color
      : type && type === "cancel"
      ? theme.button.cancel.textColor
      : type && type === "delete"
      ? theme.button.deleteOutline.textColor
      : theme.colors.main.textSecondary};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.fontWeights.regular};
  border: 1px solid
    ${({ borderColor, primary, type, theme }) =>
      borderColor
        ? borderColor
        : primary
        ? theme.button.primary.bgColor
        : type && type === "cancel"
        ? theme.button.cancel.borderColor
        : type && type === "delete"
        ? theme.button.deleteOutline.borderColor
        : theme.colors.border.secondaryLight};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  border-radius: ${({ borderRadius }) => borderRadius || "32px"};

  &:hover {
    border-color: ${({ hoverBorderColor, primary, type, theme, disabled }) =>
      disabled
        ? theme.input.borderColor.default
        : hoverBorderColor
        ? hoverBorderColor
        : primary
        ? theme.button.primary.bgColor
        : type === "nav"
        ? theme.dropdown.borderColor.hover
        : type === "cancel"
        ? theme.button.cancel.hoverBorderColor
        : type === "delete"
        ? theme.button.deleteOutline.hoverBorderColor
        : theme.button.cancel.hoverBorderColor};
    color: ${({ theme, primary }) => primary && theme.button.primary.bgColor};
    box-shadow: ${({ theme, disabled }) =>
      disabled ? "none" : theme.dropdown.focusShadow};
  }
`;
export const ColoredButton = styled(CommonDivButton)`
  min-height: ${({ height, theme }) => height || theme.button.height};
  border-radius: ${({ borderRadius }) => borderRadius || "30px"};
  padding: ${({ padding }) => padding || "0 16px 0 16px"};
  background-color: ${({ bgColor, type, theme }) =>
    bgColor
      ? bgColor
      : type && type === "delete"
      ? theme.button.deleteFilled.bgColor
      : type && type === "blue"
      ? theme.button.blueButton.bgColor
      : type && type === "gray"
      ? theme.button.grayButton.bgColor
      : type && type === "grayMedium"
      ? theme.button.grayMediumButton.bgColor
      : type && type === "black"
      ? theme.button.blackButton.bgColor
      : theme.button.primary.bgColor};
  color: ${({ color, theme }) => color || theme.colors.main.white};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.fontWeights.semibold};
  border: none;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  &:hover {
    background-color: ${({ hoverBgColor, bgColor, type, theme, disabled }) =>
      !disabled &&
      (hoverBgColor
        ? hoverBgColor
        : bgColor
        ? bgColor
        : type && type === "delete"
        ? theme.button.deleteFilled.hoverBgColor
        : type && type === "blue"
        ? theme.button.blueButton.hoverBgColor
        : type && type === "gray"
        ? theme.button.grayButton.hoverBgColor
        : type && type === "grayMedium"
        ? theme.button.grayMediumButton.hoverBgColor
        : type && type === "black"
        ? theme.button.blackButton.hoverBgColor
        : theme.button.primary.hoverBgColor)};
  }
  @media (max-width: 485px) {
    font-size: ${({ fontSizeMobile, theme }) => fontSizeMobile || "11px"};
  }
`;

export const PrimaryWhiteBgButton = styled.div`
  background-color: #ffffff;
  border-radius: 32px;
  border: 1px solid #2266ef;
  width: max-content;
  height: 40px;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ marginTop }) => marginTop || "0px"};
  font-size: 14px;
  font-weight: 700;
  padding: 0 16px;
  font-family: "Mona Sans", sans-serif;
  color: #2266ef;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? "none" : "auto")};
  transition: all 0.2s ease;
  &:hover {
    ${props =>
      !props.disabled &&
      `
      background-color: #2266ef;
      color: #ffffff;
    `}
  }
`;


export const PrimaryBgButton = styled.div`
  background-color: #2266ef;
  border-radius: 32px;
  border: 1px solid #2266ef;
  width: max-content;
  height: 40px;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ marginTop }) => marginTop || "0px"};
  font-size: 14px;
  font-weight: 700;
  padding: 0 16px;
  color: white;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? "none" : "auto")};
  transition: all 0.2s ease;
  &:hover {
    background-color: ${({ hoverBgColor, bgColor, type, theme, disabled }) =>
      !disabled &&
      (hoverBgColor
        ? hoverBgColor
        : bgColor
        ? bgColor
        : type && type === "delete"
        ? theme.button.deleteFilled.hoverBgColor
        : type && type === "blue"
        ? theme.button.blueButton.hoverBgColor
        : type && type === "gray"
        ? theme.button.grayButton.hoverBgColor
        : type && type === "grayMedium"
        ? theme.button.grayMediumButton.hoverBgColor
        : type && type === "black"
        ? theme.button.blackButton.hoverBgColor
        : theme.button.primary.hoverBgColor)};
    color: ${({ hoverTextColor, theme }) => hoverTextColor || theme.colors.main.white};
  }
`;


export const EditButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 28px;
  background-color: ${({ theme }) => theme.colors.main.gray};
  border-radius: ${({ theme }) => theme.borderRadii.circle};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.hover.gray};
  }
`;

export const DefaultLocationSetButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 28px;
  background-color: ${({ theme }) => theme.colors.main.gray};
  border-radius: ${({ theme }) => theme.borderRadii.circle};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.hover.gray};
  }
`;

export const DeleteButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 28px;
  background-color: ${({ theme }) => theme.colors.main.error};
  border-radius: ${({ theme }) => theme.borderRadii.circle};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.hover.error};
  }
`;

export const ButtonIcon = styled.img`
  width: ${({ size }) => size || "18px"};
  height: ${({ size }) => size || "18px"};
  margin-top: -2px;
`;

export const ExportButtonIcon = styled(ButtonIcon)`
  filter: grayscale(0) brightness(0) opacity(1);
  color: #767676;
  transition: color 0.3s ease;
`;
export const WhiteButtonWithIcon = styled(WhiteButton)`
  grid-column-gap: 8px;
  margin: ${({ margin }) => margin};
  height: max-content;
  //add mobiloe font size
  @media (max-width: 485px) { 
    font-size: ${({ fontSizeMobile, theme }) => fontSizeMobile || "11px"};
  }
`;

export const GrayBox = styled.div`
  // background-color: #f0f0f0;
  color: #888;
  // padding: 8px 12px;
  // border-radius: 6px;
  font-size: 12px;
  display: inline-block;
`;

export const ColoredButtonWithIcon = styled(ColoredButton)`
  grid-column-gap: 8px;
  margin: ${({ margin }) => margin};
  border-radius: ${({ borderRadius }) => borderRadius || "32px"};

`;
export const ExportButtonWithIcon = styled(WhiteButton)`
  grid-column-gap: 8px;
  margin: ${({ margin }) => margin};
  font-weight: bold;
  margin-bottom: ${({ showShadow }) => (showShadow ? "20px" : "0")};

  background-color: white;
  color: #767676;
  border: 1px solid #6fa4ea;

  &:hover {
    background-color: #6fa4ea;
    color: white;
    border-color: #4294ff;

    ${ExportButtonIcon} {
      color: white;
      filter: brightness(0) saturate(100%) invert(100%);
    }
  }
`;

export const ModalDeleteButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${({ height, theme }) => height || theme.button.height};
  width: ${({ width }) => width || "auto"};
  padding: ${({ padding }) => padding || "0 25px"};

  color: ${({ theme }) => theme.button.deleteFilled.textColor};
  font-size: ${({ theme }) => theme.button.fontSize};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  border-radius: ${({ theme }) => theme.button.borderRadius};
  background-color: ${({ theme }) => theme.button.deleteFilled.bgColor};
  border: none;

  &:hover {
    background-color: ${({ disabled, theme }) =>
      !disabled && theme.button.deleteFilled.hoverBgColor};
  }
  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) =>
      theme.button.deleteFilled.disabledBgColor};
  }
  &:focus {
    outline: none;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 1.8rem;
  border: none;
  background: transparent;
  cursor: pointer;
  z-index: 1051;

  border-radius: 50%;
  width: 28px;
  height: 28px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #000;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
    transform: scale(1.15);
    color: #2266ef;
  }
`;

export const TabButtonContainer = styled.div`
  display: grid;
  width: ${({ width }) => width || "auto"};
  grid-template-columns: ${({ columns }) => columns || `auto auto`};
  justify-content: start;
  align-items: center;
  grid-column-gap: 5px;
  height: min-content;
  border: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
  border-radius: ${({ theme }) => theme.borderRadii.button};
  background-color: ${({ theme }) => theme.colors.main.white};
  padding: 3px;
  margin: ${({ margin }) => margin};
  /* --- NEW Custom Responsive Breakpoint --- */
  ${({ responsiveBreakpoint }) =>
    responsiveBreakpoint &&
    css`
      @media (max-width: ${responsiveBreakpoint}) {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
      }
    `}

  ${({ disableResponsive }) =>
    !disableResponsive &&
    css`
      @media (max-width: 412px) {
        grid-template-columns: 1fr;
        grid-row-gap: 5px;
        width: 100%;

        & > * {
          width: 100%; /* stretch full width in responsive mode */
          text-align: center;
          justify-self: center;
        }
      }
    `}
`;

export const TabButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  font-size: 13px;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  padding: 0 12px;
  border-radius: 6px;
  color: ${({ index, selected, theme }) =>
    index === selected ? theme.colors.main.white : theme.colors.main.textMain};
  background-color: ${({ index, selected, theme }) =>
    index == selected ? theme.colors.main.primary : theme.colors.main.white};
  cursor: pointer;
  border: 1px solid
    ${({ index, selected, theme }) =>
      index == selected ? theme.colors.main.primary : `transparent`};

  &:hover {
    border-color: ${({ theme }) => theme.colors.main.primary};
  }
`;

const rotate = active => keyframes`
  0% {
		transform: rotate(0deg)
	}
  20% {
    transform: rotate(45deg);
  }
	50% {
    transform: rotate(180deg)
  }
	80% {
		transform: rotate(340deg)
	}
	100% {
    transform: rotate(360deg);
	}
`;
export const RefreshButton = styled.div`
  grid-column-gap: 8px;
  margin: ${({ margin }) => margin};
  min-height: ${({ height, theme }) => height || theme.button.height};
  width: ${({ width }) => width};
  padding: ${({ padding }) => padding || "0 10px"};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  background-color: ${({ theme }) => theme.colors.main.blue};
  border-radius: ${({ theme }) => theme.button.borderRadius};
  color: ${({ color, theme }) => color || theme.colors.main.white};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.fontWeights.semibold};

  &:hover {
    border-color: ${({ theme }) => theme.colors.main.blue};
    background-color: ${({ theme }) => theme.colors.hover.blue};
  }

  ${({ isLoading }) =>
    isLoading &&
    css`
      ${ButtonIcon} {
        animation: ${rotate} 1.2s linear infinite;
      }
    `}
`;

export const RadiusButton = styled(CommonDivButton)`
  min-height: 36px;
  background-color: ${({ active, theme }) =>
    active ? theme.button.primary.bgColor : theme.button.sandButton.bgColor};
  border: 1px solid;
  border-color: ${({ active, theme }) =>
    active ? theme.button.primary.bgColor : theme.button.sandButton.bgColor};
  color: ${({ active, theme }) =>
    active ? theme.colors.main.white : theme.button.sandButton.textColor};
  font-size: ${({ theme }) => theme.button.fontSize};
  font-weight: ${({ theme }) => theme.button.sandButton.fontWeight};
  padding: 0 12px;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    border-color: ${({ theme }) => theme.button.primary.bgColor};
  }
`;

export const FilterButton = styled(CommonDivButton)`
  padding: ${({ padding }) => padding || "0 25px"};
  margin: ${({ margin }) => margin || "0"};
  /* min-height: ${({ height, theme }) => height || theme.button.height}; */
  height: ${({ height }) => height || "40px"};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.fontWeights.regular};
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.button.secondary.bgColor};
  border: 1px solid
    ${({ borderColor, theme }) =>
      borderColor ? borderColor : theme.input.borderColor.default};
  border-radius: ${({ borderRadius }) => borderRadius || "6px"};
  padding: ${({ padding }) => padding || "0"};
  box-sizing: border-box;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  pointer-events: ${({ disabled }) => (disabled ? "visible" : "auto")};

  &:hover {
    border-color: ${({ theme }) => theme.dropdown.borderColor.hover};
    box-shadow: ${({ theme }) => theme.dropdown.focusShadow};
  }
  @media (max-width: 412px) {
    margin: 0;
  }
`;

export const ToggleGroup = styled.div`
  display: flex;
  gap: 10px;
`;

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  border: 2px solid
    ${({ selected }) => (selected ? "#ff7a00" : "#c5c5c5")};
  background-color: ${({ selected }) =>
    selected ? "rgba(255,122,0,0.1)" : "white"};
  color: ${({ selected }) => (selected ? "#ff7a00" : "#555")};
  transition: 0.2s ease;

  &:hover {
    border-color: ${({ selected }) =>
      selected ? "#ff7a00" : "#999"};
  }
`;

export const Dot = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid
    ${({ selected }) => (selected ? "#ff7a00" : "#c5c5c5")};
  background-color: ${({ selected }) =>
    selected ? "#ff7a00" : "transparent"};
`;

export const BorderButtonWithIcon = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) => columns || "auto auto"};
  grid-column-gap: 8px;
  justify-content: center;
  align-items: center;
  min-height: ${({ height, theme }) => height || theme.button.height};
  padding: ${({ padding }) => padding || '0 25px 0 15px'};
  border: 1px solid
    ${({ borderColor, theme }) => borderColor || theme.button.primary.bgColor};
  border-radius: ${({ borderRadius, theme }) =>
    borderRadius || theme.button.borderRadius};
  margin: ${({ margin }) => margin || '0'};
  cursor: pointer;
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.colors.main.white};
  color: ${({ textColor, theme }) => textColor || theme.button.primary.bgColor};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.button.primary.fontWeight};

  &:hover {
    background-color: ${({ hoverBgColor, theme }) =>
      hoverBgColor || theme.button.primary.bgColor};
    color: ${({ hoverTextColor, theme }) =>
      hoverTextColor || theme.colors.main.white};

    /* Make the icon white on hover */
    ${ButtonIcon} {
      filter: brightness(0) saturate(100%) invert(100%);
    }
  }
`;

export const ButtonTakingFullWidth = styled.button`
  background-color: transparent;
  border: 1px solid
    ${({ borderColor, theme }) => borderColor || theme.button.primary.bgColor};
  border-radius: ${({ borderRadius, theme }) =>
    borderRadius || theme.button.borderRadius};
  padding: ${({ padding }) => padding || "0 25px 0 15px"};
  font-weight: 600;
  margin: ${({ margin }) => margin || "0"};
  cursor: pointer;
  min-height: ${({ height, theme }) => height || theme.button.height};
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.colors.main.white};
  color: ${({ textColor, theme }) => textColor || theme.button.primary.bgColor};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.button.primary.fontWeight};
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;

  color: ${({ textColor, theme }) => textColor || theme.button.primary.bgColor};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.button.primary.fontWeight};

  &:hover {
    background-color: ${({ hoverBgColor, theme }) =>
      hoverBgColor || theme.button.primary.bgColor};
    color: ${({ hoverTextColor, theme }) =>
      hoverTextColor || theme.colors.main.white};

    /* Make the icon white on hover */
    ${ButtonIcon} {
      filter: brightness(0) saturate(100%) invert(100%);
    }
  }
`;


export const ConfirmButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width || 'auto'};
  min-height: ${({ height, theme }) => height || theme.button.height};
  padding: ${({ padding }) => padding || '0 25px 0 15px'};
  border: 1px solid
    ${({ borderColor, theme }) => borderColor || theme.button.primary.bgColor};
  border-radius: ${({ borderRadius, theme }) =>
    borderRadius || theme.button.borderRadius};
  margin: ${({ margin }) => margin || '0'};
  cursor: pointer;
  background-color: ${({ bgColor, theme }) => bgColor || theme.button.primary.bgColor};
  color: ${({ textColor, theme }) => textColor || theme.colors.main.white};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) => fontWeight || theme.button.primary.fontWeight};
  &:hover {
    background-color: ${({ hoverBgColor, theme }) => hoverBgColor || theme.button.primary.hoverBgColor};
    color: ${({ hoverTextColor, theme }) => hoverTextColor || theme.colors.main.white};
  }
`;